import { render, staticRenderFns } from "./SchoolAbout.vue?vue&type=template&id=35606df8&scoped=true&"
import script from "./SchoolAbout.vue?vue&type=script&lang=ts&"
export * from "./SchoolAbout.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolAbout.vue?vue&type=style&index=0&id=35606df8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35606df8",
  null
  
)

export default component.exports